export default {
  dataModel: {
    types: ['pair:Status', 'cdlt:CourseStatus', 'cdlt:PathStatus'],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
};
